import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export function SEO({ title, description }) {
  useEffect(() => {
    let finalTitle = 'Vægsystem3E | AGT Nordic Group ApS';
    if (title && title !== 'Forside') {
      finalTitle = `${title} - AGT Nordic Group ApS`;
    }
    document.title = finalTitle;

    let metaDesc = document.querySelector('meta[name="description"]');
    if (!metaDesc) {
      metaDesc = document.createElement('meta');
      metaDesc.name = 'description';
      document.head.appendChild(metaDesc);
    }
    metaDesc.content =
      description ||
      'AGT Nordic Group ApS er den eksklusive eneforhandler af SYSTEM 3E i Danmark. Oplev det revolutionerende modulære perlit vægsystem med Click-Click montage uden mørtel eller lim.';
  }, [title, description]);

  return null;
}

export function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}
